"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orgNgb = void 0;
exports.orgNgb = {
    id: 530,
    name: 'NGB Organization'
};
